import { AxiosResponse } from 'axios';
import { appContextGet, appContextPut } from './httpCommon/appAxios.service';
import { MARKETPLACE_COMMISSION_API_ENDPOINTS } from '../constants/apiEndpoints';
import type {
  MarketplaceCommission,
} from '../types/interfaces/marketPlace.interfaces';

export const getMarketplaceCommissionById = (id: number): Promise<AxiosResponse<MarketplaceCommission>> => {
  return appContextGet(`${MARKETPLACE_COMMISSION_API_ENDPOINTS.GET_BY_ID}${id}`);
};

export const updateMarketplaceCommission = (
  id: number,
  payload: MarketplaceCommission,
): Promise<AxiosResponse<MarketplaceCommission>> => {
  return appContextPut(`${MARKETPLACE_COMMISSION_API_ENDPOINTS.PUT}${id}`, payload);
};
